/** How long a read of a whole Workbook stays fresh: the page and its parts share one read. */
export const WORKBOOK_FRESH_MS = 30_000;
